import React from 'react'
import Navabar from '../../components/Navbar/Navabar'
import Header from '../../components/Header/Header'

const Home = () => {
  return (
    <>
        <Navabar/>
        <Header/>
    </>
  )
}

export default Home